export default {
        exbidite: [
          'Pick up declined',
          'Two Days Scan requested',
        ],
        urgent: [
          'Expedited forward requested',
          'Same Day Scan requested'
        ],
        urgent: [
          'Expedited forward requested',
          'Same Day Scan requested'
        ],
        regular: [
          'Shred requested',
          'Scan requested',
          'Forward requested',
          'Expedited forward requested',
          'Envelope picture requested',
          'Pick up requested',
          'Mark as pick up requested',
          'Mark as junk',
          'Marked as pick up requested by the user',
          'Check deposit requested',
          'Stored',
          'Junk Mail',
          'Discard requested',
        ],
        terminalMailActions: ['Picked up' , 'Mail forwarded' , 'Shredded']
}

